// Gives ES modules the jQuery loaded from the CDN <script> tag, so `import $ from 'jquery'` does
// not bundle a second copy.
//
// A Turbo visit re-runs that CDN script in the new <body>, which replaces window.$ and
// window.jQuery with a fresh instance carrying freshly registered plugins. Legacy code reads the
// global on every call, so this forwards every call and property access to whichever instance is
// current.
//
// It follows window.$, as legacy code does: a third-party jQuery that calls noConflict() (the
// WordPress copy does) takes over window.jQuery without our plugins but hands $ back to ours.
//
// Legacy files inline this module, and their top-level names become page globals, so none of them
// may be called jQuery or $.
const currentJQueryInstance = () => (window.$?.fn?.jquery ? window.$ : window.jQuery);

const jQueryProxy = new Proxy(function () {}, {
  apply: (_target, thisArg, args) => currentJQueryInstance().apply(thisArg, args),
  construct: (_target, args) => new (currentJQueryInstance())(...args),
  get: (_target, property) => currentJQueryInstance()[property],
  set: (_target, property, value) => {
    currentJQueryInstance()[property] = value;
    return true;
  },
  has: (_target, property) => property in currentJQueryInstance(),
});

export { jQueryProxy as default, jQueryProxy as jQuery };
